import React from 'react'
import { IntegrationsPrestaShopSec } from './integrationsPrestaShopSec'

export const IntegrationsPrestaShop = () => {
  return (
    <IntegrationsPrestaShopSec />
  )
}
